import React, { useEffect, useState } from 'react';
import { Button, Card, Spinner, Alert, Container, Row, Col, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

const API_URL = 'https://blistbackend.aihelth.com/blistserver/api/businesses.php';

const DownloadVisitingCards = () => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(API_URL)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setBusinesses(data);
        } else if (Array.isArray(data.businesses)) {
          setBusinesses(data.businesses);
        } else {
          setError('No businesses found.');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load businesses.');
        setLoading(false);
      });
  }, []);


  // Modern, professional, double-sided SVG visiting card
  const getFrontSVG = (business) => `
    <svg width="400" height="200" viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="bg-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#0d5097"/>
          <stop offset="100%" stop-color="#1e90ff"/>
        </linearGradient>
      </defs>
      <rect width="400" height="200" rx="18" fill="url(#bg-gradient)"/>
      <circle cx="60" cy="60" r="32" fill="#fff" />
      <image href="https://blistbackend.aihelth.com/blistserver/api/uploads/1752914343_1000063407.jpg" x="28" y="28" height="64" width="64" clip-path="circle(32px at 60px 60px)"/>
      <text x="120" y="60" font-size="26" fill="#fff" font-family="Segoe UI, Arial, sans-serif" font-weight="bold">${business.name || 'Your Name'}</text>
      <text x="120" y="90" font-size="16" fill="#e0e7ef" font-family="Segoe UI, Arial, sans-serif">${business.designation || 'Designation'}</text>
      <text x="120" y="120" font-size="15" fill="#e0e7ef" font-family="Segoe UI, Arial, sans-serif">${business.email || 'email@example.com'}</text>
      <text x="120" y="145" font-size="15" fill="#e0e7ef" font-family="Segoe UI, Arial, sans-serif">${business.phone || '+91 12345 67890'}</text>
      <text x="120" y="170" font-size="15" fill="#e0e7ef" font-family="Segoe UI, Arial, sans-serif">${business.website || 'www.example.com'}</text>
    </svg>
  `;

  const getBackSVG = (business) => `
    <svg width="400" height="200" viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg">
      <rect width="400" height="200" rx="18" fill="#fff" stroke="#0d5097" stroke-width="2"/>
      <text x="50%" y="60" font-size="18" fill="#0d5097" font-family="Segoe UI, Arial, sans-serif" text-anchor="middle">${business.company || business.name || 'Company Name'}</text>
      <text x="50%" y="100" font-size="15" fill="#222" font-family="Segoe UI, Arial, sans-serif" text-anchor="middle">${business.address || 'Full Address, City, State, ZIP'}</text>
      <text x="50%" y="140" font-size="15" fill="#222" font-family="Segoe UI, Arial, sans-serif" text-anchor="middle">${business.website || 'www.example.com'}</text>
    </svg>
  `;

  const handleDownload = (business) => {
    // Download both front and back SVGs
    const frontSVG = getFrontSVG(business);
    const backSVG = getBackSVG(business);
    // Download front
    const frontBlob = new Blob([frontSVG], { type: 'image/svg+xml' });
    const frontUrl = URL.createObjectURL(frontBlob);
    const frontLink = document.createElement('a');
    frontLink.href = frontUrl;
    frontLink.download = `${business.name || 'visiting-card'}-front.svg`;
    document.body.appendChild(frontLink);
    frontLink.click();
    document.body.removeChild(frontLink);
    URL.revokeObjectURL(frontUrl);
    // Download back
    const backBlob = new Blob([backSVG], { type: 'image/svg+xml' });
    const backUrl = URL.createObjectURL(backBlob);
    const backLink = document.createElement('a');
    backLink.href = backUrl;
    backLink.download = `${business.name || 'visiting-card'}-back.svg`;
    document.body.appendChild(backLink);
    backLink.click();
    document.body.removeChild(backLink);
    URL.revokeObjectURL(backUrl);
  };

  // Card preview toggle
  const [previewSide, setPreviewSide] = useState('front');

  if (loading) return <Spinner animation="border" className="d-block mx-auto my-5" />;
  if (error) return <Alert variant="danger">{error}</Alert>;


  return (
    <Container className="my-5">
      <h2 className="mb-4">Download Visiting Cards</h2>
      <Row className="g-4">
        {businesses.map(biz => (
          <Col md={6} lg={4} sm={12} key={biz.id}>
            <Card className="mb-3 shadow-sm p-2">
              <Card.Body>
                <Card.Title>{biz.name}</Card.Title>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                  <ToggleButtonGroup type="radio" name="side" value={previewSide} onChange={setPreviewSide} size="sm">
                    <ToggleButton id="front" value="front" variant="outline-primary">Front</ToggleButton>
                    <ToggleButton id="back" value="back" variant="outline-secondary">Back</ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div style={{ background: previewSide === 'front' ? 'linear-gradient(90deg,#0d5097,#1e90ff)' : '#fff', borderRadius: 12, boxShadow: '0 2px 8px #0001', padding: 8, marginBottom: 12 }}>
                  <div dangerouslySetInnerHTML={{ __html: previewSide === 'front' ? getFrontSVG(biz) : getBackSVG(biz) }} style={{ width: 400, height: 200, maxWidth: '100%' }} />
                </div>
                <Button variant="primary" onClick={() => handleDownload(biz)}>
                  Download Visiting Card (Front & Back)
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DownloadVisitingCards;
